/**
 * utils/inputmask.js — маски на полях по селекторам.
 * Только jQuery (глобально) + плагин inputmask. Другие файлы из utils/ не требуются.
 */
jQuery(document).ready(function () {
    if (!jQuery.fn.inputmask) {
        return;
    }
    jQuery('input[type="tel"]').inputmask({
        mask: "+7 (999) 999-99-99",
        showMaskOnHover: false,
        showMaskOnFocus: true
    });

    jQuery('input[type="email"]').inputmask({
        alias: "email",
        showMaskOnHover: false,
        showMaskOnFocus: false
    });
});
